import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

const styles = theme => ({
  listItem: {
    color: theme.palette.text.primary,
    minWidth: 140,
    padding: 0,
    '& + $listItem': {
      paddingTop: 15,
    },
  },
});

const PatientsTableRowInsuranceInformation = ({ classes, ...otherProps }) => (
  <List disablePadding>
    {otherProps['Insurance Information'].map(item => (
      <ListItem
        key={item.ID}
        className={classes.listItem}
      >
        {`${item['Insurance Info']['Payer Name']} (${item['Insurance ID']})`}
      </ListItem>
    ))}
  </List>
);

PatientsTableRowInsuranceInformation.propTypes = {
  'Insurance Information': PropTypes.arrayOf(
    PropTypes.shape({
      ID: PropTypes.number.isRequired,
      'Insurance ID': PropTypes.string.isRequired,
      'Insurance Info': PropTypes.shape({
        'Payer Name': PropTypes.string,
      }),
    }),
  ).isRequired,
  classes: PropTypes.shape({
    listItem: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(PatientsTableRowInsuranceInformation);



// WEBPACK FOOTER //
// ./src/components/patient/PatientsTable/PatientsTableRowInsuranceInformation.js